import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Quote } from "lucide-react";

// Funny + motivational Hindi quotes nudging users to buy. Keep adding freely.
const QUOTES = [
  { hi: "किराया भरते-भरते थक गए? अब अपना घर लो!", en: "Tired of paying rent? Time to own your home." },
  { hi: "पड़ोसी की नई गाड़ी देखी? अब आपकी बारी है।", en: "Saw the neighbour's new car? Your turn now." },
  { hi: "मकान नहीं, अपना मुकाम खरीदिए।", en: "Don't just buy a house — buy your milestone." },
  { hi: "आज का सौदा, कल की शान।", en: "Today's deal, tomorrow's pride." },
  { hi: "भाड़े का घर दिल पे बोझ, अपना घर चैन की नींद।", en: "Rented stress vs. owned peace of mind." },
  { hi: "सपनों का घर आज नहीं तो कब?", en: "If not today, then when?" },
  { hi: "जेब नहीं, सपने देखकर खरीदिए — VYAPAAR है ना!", en: "Chase dreams, not just budgets — VYAPAAR's got you." },
  { hi: "अच्छा सौदा वही, जो भरोसे के साथ मिले।", en: "A good deal is one you can trust." },
];

export default function HeroQuote() {
  const [i, setI] = useState(() => Math.floor(Math.random() * QUOTES.length));

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % QUOTES.length), 4500);
    return () => clearInterval(t);
  }, []);

  const quote = QUOTES[i];

  return (
    <div className="mt-4 flex items-start gap-2.5" data-testid="hero-quote">
      <Quote className="h-4 w-4 text-gold shrink-0 mt-1" />
      <div className="min-h-[3.2rem]">
        <AnimatePresence mode="wait">
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.4 }}
          >
            <p className="font-display text-lg sm:text-xl font-semibold text-gold leading-snug" data-testid="hero-quote-hi">
              {quote.hi}
            </p>
            <p className="text-xs text-blue-100/70 mt-0.5">{quote.en}</p>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
